export type ReworkSelectionCommand = {
	id: number;
};

export type ReworkSelectionInput = {
	currentReworkCommand?: ReworkSelectionCommand;
	currentReworkCommandOld?: string;
	nextReworkCommand?: ReworkSelectionCommand;
	nextReworkCommandOld?: string;
};

export const getReworkSelectionChange = ({
	currentReworkCommand,
	currentReworkCommandOld,
	nextReworkCommand,
	nextReworkCommandOld,
}: ReworkSelectionInput) => {
	const hasCurrentCommand = currentReworkCommand !== undefined;
	const hasNextCommand = nextReworkCommand !== undefined;
	const currentCommandId = currentReworkCommand?.id;
	const nextCommandId = nextReworkCommand?.id;
	const currentCommandOld = currentReworkCommandOld?.trim();
	const nextCommandOld = nextReworkCommandOld?.trim();

	const hasChanged =
		currentCommandId !== nextCommandId || currentCommandOld !== nextCommandOld;

	return {
		hasChanged,
		shouldHydrateReworkSetup:
			hasChanged &&
			(hasCurrentCommand ||
				hasNextCommand ||
				(currentCommandOld !== undefined && currentCommandOld !== "") ||
				(nextCommandOld !== undefined && nextCommandOld !== "")),
	};
};
